import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'

export const useCanvasScale = (canvasWrapperEl: HTMLDivElement | null) => {
  const [scale, setScale] = useState(0)

  const { width: projectDefaultWidth } = useSelector(
    projectDataSelectors.defaultDimensions
  )

  useEffect(() => {
    if (!canvasWrapperEl) return

    const updateScale = () => {
      setScale(canvasWrapperEl.clientWidth / projectDefaultWidth)
    }

    updateScale()
    const resizeObserver = new ResizeObserver(updateScale)
    resizeObserver.observe(canvasWrapperEl)

    return () => resizeObserver.disconnect()
    // TODO: Recheck this
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasWrapperEl, projectDefaultWidth])

  return scale
}
